/**
 * playbackProfile — which recording profile a cloud multi-cam playback TILE should prefer.
 *
 * Dragon records a lighter LIVE-profile twin (pro2) next to each main clip (pro1). Multi-cam
 * grids prefer pro2 to cut decode load; a camera shown LARGE uses pro1 for full detail, since
 * only one stream decodes there anyway:
 *   - conf-1 (single cam)                        → pro1
 *   - a cell zoomed to single (double-click / ⤢) → pro1
 *   - the conf-8 hero (big top-left) on desktop  → pro1; its 7 small tiles → pro2
 *   - every other multi-cam tile                 → pro2 (with a pro1 fallback if the twin is absent)
 *
 * Pure + layout-only so it unit-tests without a DOM: the caller supplies the resolved tier flag
 * (isDesktop) rather than reading matchMedia here. Whether the twin actually EXISTS is a separate
 * concern (the clip carries sMoviePro2; the player falls back on a 404) — this decides intent only.
 *
 * @param {object} o
 * @param {number} o.conf         numeric tile count of the shared grid (1,2,4,6,8,9,16…)
 * @param {number} o.slotIndex    this tile's slot position (0-based)
 * @param {?number} o.zoomedSlot  the slot zoomed-to-single, or null/undefined when none is
 * @param {boolean} o.isDesktop   true at the desktop tier (≥1280), where the conf-8 hero renders large
 * @returns {boolean} true → prefer pro2 (twin, with pro1 fallback); false → pro1 only
 */
export const slotPrefersPro2 = ({ conf, slotIndex, zoomedSlot, isDesktop } = {}) => {
  // A zoomed cell fills the viewer as a single-cam view → pro1; its hidden siblings keep decoding
  // pro2 (they stay mounted for sync, so the lighter stream still helps).
  if (zoomedSlot != null) return zoomedSlot !== slotIndex;
  if (!(conf > 1)) return false;                                 // conf-1 / single → pro1
  if (isDesktop && conf === 8 && slotIndex === 0) return false;  // conf-8 desktop hero → pro1
  return true;                                                   // other multi-cam tiles → pro2
};

export default slotPrefersPro2;
